import React from 'react';
import { getService } from '@Client/runner.hooks/useService';
import DownloadableReportTable from '@Client/runner.reportsv2/DownloadableReportTable';

const ProcedureReportsTab = () => {
  const APP_CONFIG = getService('APP_CONFIG');
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const reports = [
    {
      name: 'SOPs Report',
      description: 'Basic information about all Standard Operating Procedures.',
      url: APP_CONFIG.apiBaseUrl + 'reports/procedures/csvV2',
      testId: 'sops-report-download',
      parameters: {
        userTimeZone: userTimeZone
      }
    },
    {
      name: 'SOP Usage Report',
      description:
        'How many times Standard Operating Procedures have been viewed.',
      url: APP_CONFIG.apiBaseUrl + 'reports/procedures/usage/csvV2',
      testId: 'sop-usage-report-download',
      parameters: {
        userTimeZone: userTimeZone
      }
    }
  ];

  return (
    <div className="procedure-reports">
      <DownloadableReportTable reports={reports} />
    </div>
  );
};

export default ProcedureReportsTab;
